import React from "react";
import json2mq from 'json2mq';
import useMediaQuery from '@mui/material/useMediaQuery';
import AOS from "aos";
import "aos/dist/aos.css";
import './Navbar.scss';

const Navbar = () => {

    let navbar;
    let navbarBrand;
    let navs;
    let homeSize;

    const device=useMediaQuery(json2mq({
            maxWidth: 768
        }),
    );

    const [ isExpanded, expandMenu ] = React.useState(false);

    React.useEffect(() => {

        AOS.init();
        AOS.refresh();

        navbar=document.getElementById('navbar');
        navbarBrand = document.getElementById('navbar-brand');
        navs=document.getElementById('navs');

        homeSize=document.getElementById('home').offsetHeight;

        window.addEventListener('scroll', () => {
            const scrollBy=window.scrollY;

            if (scrollBy>homeSize/4 && scrollBy<2*homeSize/3) {
                navbar.classList.add('invisible');
            } else {
                navbar.classList.remove('invisible')
            }

            if (scrollBy<homeSize/2 || (scrollBy>2*homeSize/3 && scrollBy<homeSize-50)) {
                navbar.classList.add('white-content');
            } else {
                navbar.classList.remove('white-content');
            }

            if (scrollBy<homeSize/2) {
                navbar.classList.remove('shifting');
                navbarBrand.classList.remove('visible');
            } else {
                navbar.classList.add('shifting');
                navbarBrand.classList.add('visible');
            }
        });

    }, []);

    const toggleMenu = () => {
        const burger = document.querySelector('.burger');

        burger.classList.toggle('toggle');
        expandMenu(!isExpanded);
    }

    return (
        <div id="navbar" className="navbar pt-4 pb-3 fixed-top">

            <div className="container">
                <div id="navbar-brand" className="navbar-brand">
                    <a href="#home"><span className="initial">A</span>nshika <span className="initial">A</span>grawal</a>
                </div>
                
                <div id="navs"  className={`navs ${isExpanded && device ? 'open-nav' : ''}`} style={{display:!device?'block': isExpanded ? 'flex' : 'none'}}>
                    
                    <ul className="">
                        <div 
                            data-aos="fade-down" 
                            data-aos-delay="50"
                            data-aos-duration="900"
                            data-aos-easing="ease-in-out"
                        >
                            <li className="nav-links">
                                <a href="#about" onClick={toggleMenu}>About</a>
                            </li>
                        </div>
                        <div 
                            data-aos="fade-down" 
                            data-aos-delay="100"
                            data-aos-duration="900"
                            data-aos-easing="ease-in-out"
                        >
                            <li className="nav-links">
                                <a href="#experience" onClick={toggleMenu}>Experience</a>
                            </li>
                        </div>
                        <div 
                            data-aos="fade-down" 
                            data-aos-delay="150"
                            data-aos-duration="900"
                            data-aos-easing="ease-in-out"
                        >
                            <li className="nav-links">
                                <a href="#education" onClick={toggleMenu}>Education</a>
                            </li>
                        </div>
                        <div 
                            data-aos="fade-down" 
                            data-aos-delay="200"
                            data-aos-duration="900"
                            data-aos-easing="ease-in-out"
                        >
                            <li className="nav-links">
                                <a href="#portfolio" onClick={toggleMenu}>Portfolio</a>
                            </li>
                        </div>
                        <div 
                            data-aos="fade-down" 
                            data-aos-delay="250"
                            data-aos-duration="900"
                            data-aos-easing="ease-in-out"
                        >
                            <li className="nav-links">
                                <a href="#contact" onClick={toggleMenu}>Contact</a>
                            </li>
                        </div>
                    </ul>
                </div>

                <div className="burger" onClick={toggleMenu}>
                    <div className="line1"></div>
                    <div className="line2"></div>
                    <div className="line3"></div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;